<ng-container *ngIf="backButtonTitle">
  <button class="md:!pl-0" pm-button [pmType]="'ghost'" type="button" (click)="back()">
    <i class="mr-[10px] pt-[4px] icon-back-arrow"></i>
    {{ backButtonTitle | translate }}
  </button>
</ng-container>

